/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { MoveToGraphTransform } from "./move-to-graph.js";
import { GraphDescriptorHandle } from "../../inspector/graph/graph-descriptor-handle.js";
export { MergeGraphTransform };
class MergeGraphTransform {
    #source;
    #mergeInto;
    constructor(source, mergeInto) {
        this.#source = source;
        this.#mergeInto = mergeInto;
    }
    async apply(context) {
        const { graph } = context;
        const handle = GraphDescriptorHandle.create(graph, this.#source);
        if (!handle.success) {
            return handle;
        }
        const all = handle.result.graph().nodes.map((node) => node.id);
        const moving = await new MoveToGraphTransform(all, this.#source, this.#mergeInto).apply(context);
        if (!moving.success) {
            return moving;
        }
        const removingGraph = await context.apply([{ type: "removegraph", id: this.#source }], "");
        if (!removingGraph.success) {
            return removingGraph;
        }
        return { success: true };
    }
}
//# sourceMappingURL=merge-graph.js.map